<template lang="pug">
div.upa-modal
  modal(
    name='notification'
    transition='notification-transition'
    :pivotX='0.03'
    height='95%'
    width='33%'
    :maxWidth='329.92' :minWidth='316.8'
    :adaptive='true'
    :scrollable='false'
  )
    .d-flex.flex-column.h-100
      .sticky-top.bg-white
        .d-flex.justify-content-center.align-items-center.px-3.py-3
          img.img-40(src='@/assets/icons/email.svg')
          .text-title.ml-3 แจ้งเตือนข้อความ
        hr.m-0
      .notificaion-list.scrollable
        template(v-if='notifications === null || notifications === undefined')
          LoadingError(
            title='เกิดปัญหาในการโหลดข้อความ'
            @reload='loadData'
          )
        template(v-else-if='notifications && notifications.length === 0')
          .text-medium.text-center.py-4
            | ไม่มีข้อความแจ้งเตือน
        template(v-for='(item, i) in notifications')
          .d-flex
            .transparent-button.no-scaling.w-100.item(
              @click='$emit(`itemClicked`, item)'
            )
              .d-flex.align-items-start.px-3.py-3
                template(v-if='item.read === 0')
                  .notification-dot.small.mr-2.mt-2
                .d-flex.flex-column
                  .text-medium.text-black.text-bold.text-left
                    | {{ item.title }}
                  .text-medium.text-left
                    | {{ item.description }}
                  .text-small.mt-1
                    | {{ `NOTIF-${item.id}` }}
            div
              button.transparent-button.no-scaling(@click='onRemoveButtonClicked(item, i)')
                i.fa.fa-times
          hr.m-0

  //- modal(
  //-   name='sell-record'
  //-   width='90%' height='95%'
  //-   transition='modal-transition'
  //- )
  //-   SellRecordDetail(
  //-     :sellRecord='selectedItem'
  //-     @closeButtonClicked='hideModal'
  //-   )
  //-     //- :customer='customer'

</template>

<script>
import { mapGetters } from 'vuex';
import SellRecordDetail from '@/components/history/dialogs/SellRecord/SellRecordDetail.vue';

export default {
  data: () => ({
    notifications: [
      // {
      //   title: 'รายการขายเลขที่ 23/16179',
      //   order_id: '23/16179',
      //   message: 'ข้อความทดสอบส่งหาผู้เกี่ยวข้องเกี่ยวกับสินค้าที่...',
      // },
      // {
      //   title: 'รายการขายเลขที่ 23/20120',
      //   order_id: '23/20120',
      //   message: 'ข้อความทดสอบส่งหาผู้เกี่ยวข้องเกี่ยวกับสินค้าที่...',
      // },
    ],

    selectedItem: {},
  }),
  mounted() {
    this.loadData();
  },
  methods: {
    // ...mapMutations({
    //   setNotifications: 'setNotifications',
    // }),
    ...mapGetters({
      orderNotifications: 'orderNotifications',
    }),
    async loadData() {
      try {
        const res = await this.$api.notification.list();
        // TODO: save into STATE (or even better.. STORE)
        this.notifications = res.data;

        this.onDataLoaded();
        // console.log(res);

        // Vuex
        // this.setNotifications(this.notifications);
        // console.log(this.orderNotifications());
      } catch (e) {
        console.log(e);
        this.notifications = null;
      }
    },
    onDataLoaded() {
      this.$emit('dataLoaded', this.notifications);
    },

    // async showModal(e) {
    //   this.selectedItem = e;

    //   // load the data
    //   const res = await this.$api.order.getWithId(e.order_id);
    //   if (res.status === 200) {
    //     this.selectedItem = res.data.data;
    //   }

    //   this.$modal.show('sell-record');
    // },
    // hideModal() {
    //   this.$modal.hide('sell-record');
    // },

    async onRemoveButtonClicked(item, index) {
      try {
        // Tell API to remove
        const res = await this.$api.notification.remove(item.id, item.order_id);
        console.log(res);

        // if succeed, proceed to remove in UI
        if (res.status === 201) {
          this.notifications.splice(index, 1);
        }
      } catch (e) {
        // Something is wrong, inform the user
        alert(`เกิดข้อผิดพลาดในการลบข้อความแจ้งเตือน #${item.id}`);
      }
    },
  },

  components: {
    SellRecordDetail,
  },
};
</script>

<style lang="scss">
// .notification-panel {}
</style>
